import moment from "moment";
import React from "react";

export const historyOperationMap = {
  subject: 'Изменен предмет договора',
  endDate: 'Изменена дата окончания договора',
  paymentPlans: 'Новый срок поступления средств по договору',
  paymentPlansChange: 'Изменена сумма поступления средств по договору',
  rate: 'Изменена ставка оплаты',
};

export const getHistoryOperationDescription = (changes) => {
  console.log(changes);
  
  const { val, prevVal } = changes;
  const changesDescription = [];
  const numberFormatter = new Intl.NumberFormat('ru', {maximumFractionDigits: 2})
  Object.keys(val).forEach((key) => {
    
    if (val[key] !== prevVal[key]) {
      switch(key){
        case 'paymentPlans':
          const prevPaymentPlans = {};
          prevVal.paymentPlans.forEach((plan) => {
            prevPaymentPlans[plan.paymentBeforeDate] = plan;
          })
          val.paymentPlans.forEach(({paymentBeforeDate, sum}) => {
            const prevPlan = prevPaymentPlans[paymentBeforeDate];
            if(prevPlan && sum !== prevPlan.sum){
              changesDescription.push(<p>
                {historyOperationMap.paymentPlansChange}: <s>{moment(prevPlan.paymentBeforeDate).format('DD.MM.YYYY')} на {numberFormatter.format(prevPlan.sum)} руб</s> - {moment(paymentBeforeDate).format('DD.MM.YYYY')} на {numberFormatter.format(sum)} руб
              </p>)
              return;
            }
            changesDescription.push(`${historyOperationMap.paymentPlans}: ${moment(paymentBeforeDate).format('DD.MM.YYYY')} на ${numberFormatter.format(sum)} руб`)
          })
          break;
        case 'rate':
          changesDescription.push(`${historyOperationMap[key]}: ${prevVal[key] ? numberFormatter.format(prevVal[key]) : 'Не указано'} - ${val[key] ? numberFormatter.format(val[key]) : 'Не указано'}`);
          break;
        case 'endDate':
          changesDescription.push(`${historyOperationMap.endDate}: ${prevVal[key] ? moment(prevVal[key]).format('DD.MM.YYYY') : 'Не указано'} - ${val[key] ? moment(val[key]).format('DD.MM.YYYY') : 'Не указано'}`);
          break;
        default:
          changesDescription.push(`${historyOperationMap[key]}: ${prevVal[key] ?? 'Не указано'} - ${val[key] ?? 'Не указано'}`);
      }
    }
  });
  return changesDescription;
};
